import { render } from "./GameboardElement.vue?vue&type=template&id=1670e7fb"
import script from "./GameboardElement.vue?vue&type=script&lang=js"
export * from "./GameboardElement.vue?vue&type=script&lang=js"

import "./GameboardElement.vue?vue&type=style&index=0&id=1670e7fb&lang=scss"
script.render = render

export default script